import { VisuallyHidden } from '@entities/fleet';
import type { LimitCellView, LimitCol, LimitRowView } from '@entities/prc';
import { GridInput } from '../../ui';
import {
  CellNote,
  FormulaMark,
  InputRow,
  Restore,
  cellText,
  inputOf,
} from './styles';

export interface EditCellProps {
  row: LimitRowView;
  col: LimitCol;
  cell: LimitCellView;
  editable: boolean;
  value: string | undefined;
  pendingFormula: boolean;
  error: string | null;
  label: string;
  idPrefix: string;
  onChange: (value: string) => void;
  onRestore: () => void;
  onUndo: () => void;
}

export function EditCell({
  row,
  col,
  cell,
  editable,
  value,
  pendingFormula,
  error,
  label,
  idPrefix,
  onChange,
  onRestore,
  onUndo,
}: EditCellProps) {
  const id = `${idPrefix}-${row.row}-${col}`;
  const formulaNote = cell.formula ? `${id}-f` : undefined;
  if (!editable) {
    return (
      <>
        {cell.formula && <FormulaMark title={`Формула книги: ${cell.formula}`}>ƒ</FormulaMark>}
        {cellText(cell, 4)}
      </>
    );
  }
  if (pendingFormula) {
    return (
      <>
        <span className="pending">формула вернётся при сохранении</span>
        <Restore type="button" onClick={onUndo}>
          оставить число
        </Restore>
      </>
    );
  }
  const changed = value !== undefined && value !== inputOf(cell);
  return (
    <>
      <InputRow>
        {cell.formula && (
          <FormulaMark aria-hidden="true" title={`Считается формулой книги: ${cell.formula}`}>
            ƒ
          </FormulaMark>
        )}
        <GridInput
          id={id}
          value={value ?? inputOf(cell)}
          inputMode="decimal"
          autoComplete="off"
          spellCheck={false}
          aria-label={label}
          aria-invalid={error ? true : undefined}
          aria-describedby={
            [formulaNote, error ? `${id}-e` : null].filter(Boolean).join(' ') || undefined
          }
          data-changed={changed ? 'true' : undefined}
          onChange={(e) => onChange(e.target.value)}
        />
      </InputRow>
      {cell.formula && changed && <CellNote>формула заменится числом</CellNote>}
      {cell.formula && (
        <VisuallyHidden id={formulaNote}>Считается формулой книги {cell.formula}</VisuallyHidden>
      )}
      {!cell.formula && cell.book && !changed && (
        <Restore type="button" onClick={onRestore} title={cell.book}>
          вернуть формулу книги
        </Restore>
      )}
      {error && <VisuallyHidden id={`${id}-e`}>{error}</VisuallyHidden>}
    </>
  );
}
